import Vue from 'vue'
import Vuex from 'vuex'
let base_url = "http://admin.bonrix.in/Admin/Services/Recharge.asmx/";
let dmr_url = "http://admin.bonrix.in/Admin/Services/quickrecharge.asmx/";
let mpayapi = "f742a807d7c409fe5a17dcb30a1ece12";
Vue.use(Vuex);
let security_key = "1312";
export default new Vuex.Store({
    state: {
        _rprovider: [],
        _ppprovider: [],
        _dthprovider: [],
        _bbprovider: [],
        _eprovider: [],
        _gprovider: [],
        _llprovider: [],
        _wprovider: [],
        _commissions: [],
        _offers: [],
        _user: [],
        _balance: 0,
        _dmr: null,
    },
    getters: {
        security() {
            return security_key;
        },
        rprovider(state) {
            return state._rprovider
        },
        dmr(state) {
            return state._dmr;
        },
        ppprovider(state) {
            return state._ppprovider
        },
        dthprovider(state) {
            return state._dthprovider
        },
        bbprovider(state) {
            return state._bbprovider
        },
        eprovider(state) {
            return state._eprovider
        },
        gprovider(state) {
            return state._gprovider
        },
        llprovider(state) {
            return state._llprovider
        },
        wprovider(state) {
            return state._wprovider
        },
        commissions(state) {
            return state._commissions
        },
        user(state) {
            return state._user
        },
        balance(state) {
            return state._balance
        },
        offers(state) {
            return state._offers;
        }
    },
    mutations: {
        setdmr(state, value) {
            state._dmr = value;
        },
        setrprovider(state, value) {
            state._rprovider = value
        },
        setppprovider(state, value) {
            state._ppprovider = value
        },
        setdthprovider(state, value) {
            state._dthprovider = value
        },
        setbbprovider(state, value) {
            state._bbprovider = value
        },
        seteprovider(state, value) {
            state._eprovider = value
        },
        setgprovider(state, value) {
            state._gprovider = value
        },
        setllprovider(state, value) {
            state._llprovider = value
        },
        setwprovider(state, value) {
            state._wprovider = value
        },
        setcommissions(state, value) {
            state._commissions = value
        },
        setuser(state, value) {
            state._user = value
        },
        setbalance(state, value) {
            state._balance = value
        },
        setoffers(state, value) {
            state._offers = value
        }
    },
    actions: {
        getuser(context) {
            let doc = [];
            if (localStorage.user) {
                doc = JSON.parse(localStorage.user);
            }
            if (doc != null) context.commit("setuser", doc);
        },
        axiosget(context, payload) {
            let url = base_url + payload.url;
            let params = payload.data;
            let way = payload.way;
            return new Promise((resolve, reject) => {
                Vue.axios.get(url, { params: params }).then(function(docs) {
                    resolve(docs)
                    if (docs.data.Message == "Not Authorised.") {
                        window.localStorage.removeItem("user");
                        context.dispatch("getuser");
                        return
                    }
                    if (way != undefined) {
                        if (docs.data) context.commit(way, docs.data)
                    }
                }).catch(function(error) {
                    reject(error)
                })
            })
        },
        axiospost(context, payload) {
            let url = base_url + payload.url;
            let params = payload.data;
            return new Promise((resolve, reject) => {
                Vue.axios.get(url, { params: params }).then(function(docs) {
                    if (docs.data.Message == "Not Authorised.") {
                        window.localStorage.removeItem("user");
                        context.dispatch("getuser");
                        return resolve(docs)
                    }
                    resolve(docs)
                }).catch(function(error) {
                    reject(error)
                })
            })
        },
        axiosdmrpost(context, payload) {
            let url = dmr_url + payload.url;
            let params = payload.data;
            return new Promise((resolve, reject) => {
                Vue.axios.get(url, { params: params }).then(function(docs) {
                    if (docs.data.Message == "Not Authorised.") {
                        window.localStorage.removeItem("user");
                        context.dispatch("getuser");
                        return resolve(docs)
                    }
                    resolve(docs)
                }).catch(function(error) {
                    reject(error)
                })
            })
        },
        planapi(context, payload) {
            let url = "http://submplan.oyepe.in/MPLAN/Services/API.asmx/" + payload.url;
            let params = {
                url: 'apikey=' + mpayapi + '|' + payload.data
            }
            return new Promise((resolve, reject) => {
                Vue.axios.get(url, { params: params }).then(function(docs) {
                    if (docs.data.Message == "Not Authorised.") {
                        window.localStorage.removeItem("user");
                        context.dispatch("getuser");
                        return resolve(docs)
                    }
                    resolve(docs)
                }).catch(function(error) {
                    reject(error)
                })
            })
        },
        fetchbill(context, payload) {
            let url = "http://www.oyepe.in/ReCharge/CyberPlatBBPS.asmx/BillFatch";
            let params = payload.data;
            return new Promise((resolve, reject) => {
                Vue.axios.get(url, { params: params }).then(function(docs) {
                    if (docs.data.Message == "Not Authorised.") {
                        window.localStorage.removeItem("user");
                        context.dispatch("getuser");
                        return resolve(docs)
                    }
                    resolve(docs)
                }).catch(function(error) {
                    reject(error)
                })
            })
        },
        getbalance(context) {
            let user = context.getters.user;
            let doc = {
                'MobileNo': user.phone,
                'Password': user.password,
                'AuthKey': user.authkey,
                'Source': 'json'
            }
            let url = base_url + "BalUpdate";
            return new Promise((resolve, reject) => {
                Vue.axios.get(url, { params: doc }).then(function(docs) {
                    if (docs.data.Message == "Not Authorised.") {
                        window.localStorage.removeItem("user");
                        context.dispatch("getuser");
                        return resolve(docs)
                    }
                    if (docs.data.Data) context.commit("setbalance", docs.data.Data.Balance)
                }).catch(function(error) {
                    console.log(error);

                    reject(error)
                })
            })
        },
        showdetails(context, payload) {
            return new Promise((resolve, reject) => {
                let result = payload.data
                let temp = JSON.stringify(result);
                temp = temp.replace("{\"d\":null}", " ");
                let json = JSON.parse(temp);
                if (json.Message.includes("<") && json.Message.includes(">")) {
                    json.Message = json.Message.replace(/</gi, '').replace(/>/g, ',')
                    let fields = json.Message.split(',');
                    let cname = fields[6].split('!');
                    if (fields[5].trim() == "N") {
                        fields[5] = "NO";
                    } else {
                        fields[5] = "YES";
                    }
                    let summary = {
                        'Customer Name': cname[1],
                        'Service No': fields[1].trim(),
                        'Amount': fields[0],
                        'Bill Generate Date': fields[2].trim(),
                        'Bill Due Date': fields[3].trim(),
                        'Partial Payment': fields[5].trim()
                    }
                    resolve(summary)
                } else {
                    reject(json.Message)
                }

            })

        }


    }
})